// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React, { useState } from 'react';
import { createContainer } from 'unstated-next';

function useError() {
  const [error, setError] = useState(null);

  return {
    error,
    setError,
  };
}

export const ErrorProvider = createContainer(useError);

// Provide Higher Order Component.
export const withErrorProvider = (Component) => (props) =>
  (
    <ErrorProvider.Provider>
      <Component {...props} />
    </ErrorProvider.Provider>
  );
